import { CheckCircleTwoTone, CloseCircleTwoTone } from "@ant-design/icons";

export const renderStatus = ({ record }: any) => {
    return record?.status == "active" ? (
        <CheckCircleTwoTone twoToneColor="#52c41a" />
    ) : (
        <CloseCircleTwoTone twoToneColor="#eb2f96" />
    );
};
